module.exports = __webpack_public_path__ + "img/studyThree.c297df65.png";